/**
 * @generated SignedSource<<d9724a1b96d69054fa879f6fb50b8613>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CheckInStatus = "CHECKED_IN" | "NONE" | "NO_SHOW";
export type EventRegistrationType = "CUSTOMER" | "GUEST" | "MEMBER";
export type FormQuestionType = "BOOLEAN" | "CHECKBOXES" | "EMAIL" | "GHIN_NUMBER" | "LONG_TEXT" | "MULTIPLE_CHOICE" | "NAME" | "PHONE_NUMBER" | "TEXT" | "TOGGLE" | "TRANSPORTATION";
import { FragmentRefs } from "relay-runtime";
export type useCurrentSignUp_event$data = {
  readonly signUpForClient: {
    readonly canDelete: boolean | null | undefined;
    readonly checkedIn: CheckInStatus;
    readonly id: string;
    readonly ownerClient: {
      readonly firstName?: string | null | undefined;
      readonly fullName?: string;
      readonly id?: string;
      readonly lastName?: string | null | undefined;
      readonly memberOwnerId?: string;
      readonly profileImage?: {
        readonly publicId: string;
      } | null | undefined;
    };
    readonly registrations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly formResponses: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly booleanValue: boolean | null | undefined;
                readonly id: string;
                readonly questionConfiguration: {
                  readonly enabled: boolean;
                  readonly id: string;
                  readonly type: FormQuestionType;
                };
                readonly stringValue: string | null | undefined;
                readonly transportationType: {
                  readonly id: string;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly index: number | null | undefined;
          readonly payingCustomer?: {
            readonly id: string;
          } | null | undefined;
          readonly payingMember?: {
            readonly id: string;
          } | null | undefined;
          readonly primaryChargeType: {
            readonly chargeRuleSet: {
              readonly displayDescription: string | null | undefined;
              readonly displayName: string | null | undefined;
            };
            readonly id: string;
          } | null | undefined;
          readonly registrant: {
            readonly departmentMemberProfiles?: ReadonlyArray<{
              readonly department?: {
                readonly slug: string;
              } | null | undefined;
              readonly ghinNumber?: number | null | undefined;
            } | null | undefined> | null | undefined;
            readonly email: string | null | undefined;
            readonly firstName: string | null | undefined;
            readonly id: string;
            readonly lastName: string | null | undefined;
            readonly phoneNumber?: {
              readonly nationalNumber: string;
            } | null | undefined;
            readonly profileImage: {
              readonly publicId: string;
            } | null | undefined;
          } | null | undefined;
          readonly type: EventRegistrationType | null | undefined;
          readonly unknownRegistrantDisplayName?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly signUpWindow: {
      readonly cancelDeadlineAt: string | null | undefined;
    } | null | undefined;
    readonly waitlistIndex: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCurrentSignUp_event";
};
export type useCurrentSignUp_event$key = {
  readonly " $data"?: useCurrentSignUp_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentSignUp_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = [
  (v0/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "payingMember",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownRegistrantDisplayName",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhoneNumber",
    "kind": "LinkedField",
    "name": "phoneNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nationalNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "GOLF"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "departmentMemberProfiles",
    "plural": true,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ghinNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "GolfMemberProfile",
        "abstractKey": null
      }
    ],
    "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentSignUp_event",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "clientId",
          "variableName": "memberId"
        }
      ],
      "concreteType": "EventSignUp",
      "kind": "LinkedField",
      "name": "signUpForClient",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpWindow",
          "kind": "LinkedField",
          "name": "signUpWindow",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cancelDeadlineAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "waitlistIndex",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canDelete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkedIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "ownerClient",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": "memberOwnerId",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRegistrationConnection",
          "kind": "LinkedField",
          "name": "registrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventRegistrationEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "index",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v7/*: any*/)
                      ],
                      "type": "MemberEventRegistration",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v7/*: any*/),
                        (v8/*: any*/)
                      ],
                      "type": "GuestEventRegistration",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Customer",
                          "kind": "LinkedField",
                          "name": "payingCustomer",
                          "plural": false,
                          "selections": (v6/*: any*/),
                          "storageKey": null
                        },
                        (v8/*: any*/)
                      ],
                      "type": "CustomerEventRegistration",
                      "abstractKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventRegistrationChargeType",
                      "kind": "LinkedField",
                      "name": "primaryChargeType",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ChargeRuleSet",
                          "kind": "LinkedField",
                          "name": "chargeRuleSet",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "displayName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "displayDescription",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "registrant",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v4/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v9/*: any*/),
                          "type": "Member",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v9/*: any*/),
                          "type": "Customer",
                          "abstractKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventFormResponseConnection",
                      "kind": "LinkedField",
                      "name": "formResponses",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventFormResponseEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "EventFormResponse",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "booleanValue",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "stringValue",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "TransportationType",
                                  "kind": "LinkedField",
                                  "name": "transportationType",
                                  "plural": false,
                                  "selections": (v6/*: any*/),
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormQuestionConfiguration",
                                  "kind": "LinkedField",
                                  "name": "questionConfiguration",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "enabled",
                                      "storageKey": null
                                    },
                                    (v0/*: any*/),
                                    (v5/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "99b37fbceebb5d96d9755620d6fc290f";

export default node;
